import { useMemo } from 'react';
import { useAtomValue } from 'jotai';
import { Number3, Tileset } from '@fabric-web/3d-viewer';
import * as state from '@/components/Analysis/state';
import { getCloudfrontUrl } from '@/utils/cloudfront';

const tilesetLoaderOptions = {
  viewDistanceScale: 1,
  // Two options below forces tileset to have local coordinate system and matching point cloud (Fabric ENU)
  // resetTransform: false,
  updateTransforms: false,
  maxRequests: 20, // default: 64
  loaderGLOptions: {
    fetch: { credentials: 'include' as RequestCredentials },
  },
};

type PhotogrammetryTilesetProps = {
  onClick: (point: Number3) => void;
};

export const PhotogrammetryTileset = ({ onClick }: PhotogrammetryTilesetProps) => {
  const inspectionMetadata = useAtomValue(state.inspectionMetadata);
  const showPhotogrammetryTiles = useAtomValue(state.showPhotogrammetryTiles);

  const photogrammetryTilesPath = inspectionMetadata?.photogrammetryTilesPath;

  const tilesetComp = useMemo(() => {
    if (!showPhotogrammetryTiles) return undefined;
    if (!photogrammetryTilesPath) return undefined;

    const url = getCloudfrontUrl(photogrammetryTilesPath);

    return <Tileset url={url} loaderOptions={tilesetLoaderOptions} onClick={onClick} key={url} />;
  }, [photogrammetryTilesPath, showPhotogrammetryTiles, onClick]);

  return <>{tilesetComp}</>;
};
